import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { UpdateVolunteerForm, VolunteerFormState } from '../types';
import { FormPanel, FormSectionTitle, SectionTitle, ValidationText } from '../styles';
import { Text } from '@/components/UI/Typography/Text';
import { Box } from '@/layout/Box';
import { Flex } from '@/layout/Flex';

interface Props {
  form: VolunteerFormState;
  errors: FieldErrors<VolunteerFormState>;
  control: Control<VolunteerFormState>;
  isTablet: boolean;
  updateForm: UpdateVolunteerForm;
}

const ServicePledgeStep = ({ form, errors, control, isTablet }: Props) => {
  //   @ts-ignore
  const { t } = useTranslation();

  return (
    <FormPanel isTablet={isTablet}>
      <SectionTitle>{t('pbl.lawyerRegistration.servicePledge.section', { defaultValue: 'Section 6' })}</SectionTitle>
      <Flex gridGap={'5px'}>
        13.{' '}
        <FormSectionTitle>
          {t('pbl.lawyerRegistration.steps.servicePledge', { defaultValue: 'Service Pledge / Agreements' })}
        </FormSectionTitle>
      </Flex>
      <Text>
        {t('pbl.lawyerRegistration.servicePledge.intro', {
          defaultValue:
            'FreelegalLink aims to help those in need to access legal assistance on everyday legal problems efficiently and conveniently, combining the power of legal expertise and technology for the public good.',
        })}
      </Text>
      <br />
      <Text>
        {t('pbl.lawyerRegistration.servicePledge.requirement', {
          defaultValue: '14. To enhance efficiency and convenience, volunteer lawyers are required to agree *',
        })}
      </Text>
      <br />

      <Box padding={'10px 30px'} marginBottom={20}>
        <Text>
          {t('pbl.lawyerRegistration.servicePledge.clauseA', {
            defaultValue:
              'a. to use the DMP as the communication platform for the provision of legal service under the Scheme; and',
          })}
        </Text>
        <br />

        <Text>
          {t('pbl.lawyerRegistration.servicePledge.clauseB', {
            defaultValue:
              'b. to a service pledge of responding to the pro bono legal assistance request within 3 working days from receipt of an enquiry under the Scheme unless circumstances prevent the acceptance of the case (e.g. conflict), in which event immediate notification to the Scheme by the lawyer is required.',
          })}
        </Text>
        <br />

        <Text>
          {t('pbl.lawyerRegistration.servicePledge.clauseC', {
            defaultValue:
              'c. if the case is accepted, to complete the pro bono legal service within 14 days from the date of receipt of the enquiry, in accordance with the Scheme requirements.',
          })}
        </Text>
      </Box>
      <FormGroup>
        <Controller
          control={control}
          name="service_pledge_agreed"
          rules={{
            validate: (value) =>
              value ||
              t('pbl.lawyerRegistration.servicePledge.errors.agreementRequired', {
                defaultValue: 'You must agree to continue.',
              }),
          }}
          render={({ field }) => (
            <FormControlLabel
              control={<Checkbox checked={!!field.value} onChange={(event) => field.onChange(event.target.checked)} />}
              label={t('pbl.lawyerRegistration.servicePledge.agreement', {
                defaultValue:
                  'I confirm my agreement to the use of DMP and the service pledge as set out in paragraphs 14(a), 14(b) and 14(c) above.',
              })}
            />
          )}
        />
        {errors.service_pledge_agreed?.message && (
          <ValidationText>{errors.service_pledge_agreed.message}</ValidationText>
        )}
      </FormGroup>
    </FormPanel>
  );
};

export default ServicePledgeStep;
